export default function togglePairedCheckboxes() {
    
    // Select both checkboxes and add onchange event
    const checkboxes = document.querySelectorAll('input[type="checkbox"][data-pair]');


    checkboxes.forEach(checkbox => {

        initialComprobation(checkbox);
        checkbox.addEventListener('change', toggleCheckbox);


    });

    
    function initialComprobation(checkbox){

        const pairedCheckbox = document.querySelector(checkbox.getAttribute('data-pair'));

        if(!pairedCheckbox)
            return false;

        pairedCheckbox.checked = !checkbox.checked;

        pairedCheckbox.addEventListener('change', (event) => {
            checkbox.checked = !checkbox.checked;
        });

    
    }


    // Function that toggles checkboxes
    function toggleCheckbox(event) {
        
        const checkbox = event.target;
        const pairedCheckbox = document.querySelector(checkbox.getAttribute('data-pair'));

        if(!pairedCheckbox)
            return false;

        pairedCheckbox.checked = !pairedCheckbox.checked;

        pairedCheckbox.addEventListener('change', (event) => {
            checkbox.checked = !pairedCheckbox.checked;
        });

    }
}

